import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { CallbackModal } from '../components/CallbackModal';
import { Accordion } from '../components/ui/Accordion';
import { MapPin, Star, Scan, Languages, Calendar, MessageCircle, Phone, CheckCircle2, ArrowRight, Plus, Minus, ShieldCheck, CreditCard, Clock, UserCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
const TELEGRAM_URL = 'https://t.me/dentico_clinic';
const MAPS_URL = 'https://maps.app.goo.gl/Fhof2j1jnLA3ffqT6';
const MAPS_EMBED_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1241.0181846982155!2d-0.104187760804084!3d51.53089276153758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760f7c6534e077%3A0xa54a590bd3b2a149!2sDentico%20Clinic%20-%20Private%20Dentist%20in%20Angel%2C%20Islington!5e0!3m2!1suk!2suk!4v1769722166469!5m2!1suk!2suk';
function TelegramIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-2005" data-mp="1j5ixe3wazo0a">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-2006" data-mp="1j5alae808mq5" />
    </svg>;
}
export function ImplantyLondonRuPage() {
  const [isCallbackOpen, setIsCallbackOpen] = useState(false);
  const faqs = [{
    q: 'Сколько стоит имплантация зуба в Лондоне?',
    a: 'Стоимость имплантации зависит от клинической ситуации, типа импланта и необходимости дополнительных процедур (например, костная пластика). После консультации мы составляем прозрачный план лечения и смету.'
  }, {
    q: 'Больно ли ставить имплант?',
    a: 'Процедура проводится под местной анестезией. Во время установки импланта большинство пациентов не чувствуют боли, а после — возможен дискомфорт, который контролируется рекомендациями и обезболиванием.'
  }, {
    q: 'Сколько времени занимает имплантация?',
    a: 'Сроки зависят от случая. Обычно сначала проводится консультация и диагностика, затем установка импланта, а после периода заживления — установка коронки. Точный график определяется индивидуально.'
  }, {
    q: 'Подходит ли имплантация, если зуб давно отсутствует?',
    a: 'Да, но может потребоваться оценка состояния кости. Во время консультации мы проверяем объем кости и при необходимости обсуждаем варианты восстановления.'
  }, {
    q: 'Можно ли поставить имплант за один визит?',
    a: 'Иногда возможна одномоментная установка (immediate loading), но чаще требуется период заживления для интеграции импланта. Это определяется после тщательной диагностики.'
  }, {
    q: 'Какие импланты вы используете?',
    a: 'Мы работаем с проверенными системами имплантов премиум-класса, которые имеют долгосрочную гарантию и высокий процент приживления.'
  }, {
    q: 'Можно ли получить консультацию на русском?',
    a: 'Да, в Dentico Clinic возможно общение на русском языке во время консультации и лечения.'
  }, {
    q: 'Где находится клиника?',
    a: 'Dentico Clinic расположена в Angel / Islington, Central London (EC1V). Адрес: 360–364 City Road, London EC1V 2PY, рядом с Angel Station.'
  }];
  // Schemas
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a
      }
    }))
  };
  const procedureSchema = {
    '@context': 'https://schema.org',
    '@type': 'MedicalProcedure',
    name: 'Dental Implants',
    description: 'Surgical placement of dental implants to replace missing teeth.',
    procedureType: 'http://schema.org/SurgicalProcedure',
    provider: {
      '@type': 'Dentist',
      name: 'Dentico Clinic',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '360-364 City Road',
        addressLocality: 'London',
        postalCode: 'EC1V 2PY',
        addressCountry: 'GB'
      }
    }
  };
  return <Layout data-id="element-2007" data-mp="1vkyu30spotbm">
      <CallbackModal isOpen={isCallbackOpen} onClose={() => setIsCallbackOpen(false)} data-id="element-2008" data-mp="1vl8msw555el0" />

      {/* Structured Data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} data-id="element-2009" data-mp="13uucf9wc6ke3" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(procedureSchema)
    }} data-id="element-2010" data-mp="tq45sqpzms3j" />

      {/* 1. HERO SECTION */}
      <section className="relative bg-[#F8F5F0] overflow-hidden" data-id="element-2011" data-mp="jvlzddt6sig1">
        <div className="absolute inset-0 bg-[#EFE8DE] -skew-y-3 origin-top-left transform translate-y-20" data-id="element-2012" data-mp="otx8fmbnqox7" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-16 lg:pt-20 lg:pb-24 relative" data-id="element-2013" data-mp="1cjrm263swhii">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-2014" data-mp="1hg86ap7vqbqb">
            <div className="space-y-6" data-id="element-2015" data-mp="12ksdsomy6nw1">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#EFE8DE] text-[#2F4A3F] border border-[#D8C4A8] text-sm font-medium" data-id="element-2016" data-mp="12k0plyvojsfs">
                <span className="relative flex h-2 w-2" data-id="element-2017" data-mp="3na88hupaewqy">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-forest-600 opacity-75" data-id="element-2018" data-mp="3ncufnt89na8n"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-forest-700" data-id="element-2019" data-mp="1yrdho4llekov"></span>
                </span>
                Имплантация зубов в Лондоне
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2B2D2F] leading-tight tracking-tight" data-id="element-2020" data-mp="1p12cyfu347gx">
                Имплантация зубов в Лондоне –{' '}
                <span className="text-forest-700" data-id="element-2021" data-mp="1k1phj6p5ds2q">Dentico Clinic</span>
                <br data-id="element-2022" data-mp="1f3xrki82cg16" />
                <span className="text-2xl sm:text-3xl font-medium text-stone-500 mt-2 block" data-id="element-2023" data-mp="1f47fm09jsd48">
                  (Angel, Islington)
                </span>
              </h1>

              <p className="text-lg text-gray-600 max-w-lg leading-relaxed" data-id="element-2024" data-mp="163999bbmztih">
                Восстановление утраченных зубов с помощью современных имплантов.
                Консультация на русском языке, цифровая диагностика и прозрачный
                план лечения.
              </p>

              {/* Trust Badges */}
              <div className="flex flex-wrap gap-3 text-sm font-medium text-[#2F4A3F]" data-id="element-2025" data-mp="2vhxm1do53dh1">
                <div className="flex items-center gap-1.5 bg-[#F8F5F0] px-3 py-1.5 rounded-lg border border-[#D8C4A8] shadow-sm" data-id="element-2026" data-mp="3304633ez1hsa">
                  <Star className="w-4 h-4 text-yellow-400 fill-current" data-id="element-2027" data-mp="37xdqu5rf159s" />
                  5★ Google Reviews
                </div>
                <div className="flex items-center gap-1.5 bg-[#F8F5F0] px-3 py-1.5 rounded-lg border border-[#D8C4A8] shadow-sm" data-id="element-2028" data-mp="3hq2z6rro630w">
                  <MapPin className="w-4 h-4 text-[#2F4A3F]" data-id="element-2029" data-mp="2k32wf5ah2ti0" />
                  Angel, EC1V
                </div>
                <div className="flex items-center gap-1.5 bg-[#F8F5F0] px-3 py-1.5 rounded-lg border border-[#D8C4A8] shadow-sm" data-id="element-2030" data-mp="2p14i7xza96x6">
                  <Languages className="w-4 h-4 text-[#2F4A3F]" data-id="element-2031" data-mp="2yz262kd8d1p9" />
                  Русский язык
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 pt-4" data-id="element-2032" data-mp="98oqgtyhxkp5">
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-2033" data-mp="e8kvmwixji6a">
                  <Button variant="primary" size="lg" className="w-full gap-2" data-id="element-2034" data-mp="ue2bc6gspo62">
                    <Calendar className="w-5 h-5" data-id="element-2035" data-mp="ubxwithcz4r0" />
                    Записаться на консультацию
                  </Button>
                </a>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-2036" data-mp="14ax6qghrv8g4">
                  <Button variant="whatsapp" size="lg" className="w-full gap-2" data-id="element-2037" data-mp="1e0q7snkag564">
                    <MessageCircle className="w-5 h-5" data-id="element-2038" data-mp="1s22lesbz7uou" />
                    WhatsApp
                  </Button>
                </a>
              </div>
            </div>

            <div className="relative" data-id="element-2039" data-mp="1n0n33816o2a5">
              <div className="absolute inset-0 bg-[#D8C4A8] rounded-3xl transform rotate-3 blur-sm opacity-30" data-id="element-2040" data-mp="3ts4cspup5ggl"></div>
              <img src="https://images.unsplash.com/photo-1598256989800-fe5f95da9787?auto=format&fit=crop&w=1200&q=80" alt="Имплантация зубов - Dentico Clinic London" className="relative rounded-3xl shadow-2xl object-cover h-[300px] sm:h-[400px] lg:h-[500px] w-full" data-id="element-2041" data-mp="3ov4e5006ffzi" />
            </div>
          </div>
        </div>
      </section>

      {/* 2. WHAT ARE IMPLANTS */}
      <section className="py-16 bg-white" data-id="element-2042" data-mp="1ziz51m8hgeqa">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2043" data-mp="1lkr9nir3hlh8">
          <div className="text-center mb-10" data-id="element-2044" data-mp="1lnn95bilci7s">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-2045" data-mp="1qlf0o4fbq2bg">
              Что такое дентальная имплантация?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-2046" data-mp="1boxqhgivetqh">
              Дентальная имплантация — это самый современный метод
              восстановления утраченных зубов, который позволяет вернуть не
              только эстетику улыбки, но и полную жевательную функцию. Имплант —
              это титановый корень, который устанавливается в кость челюсти и
              служит надежной опорой для коронки или мостовидного протеза.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mt-4" data-id="element-2047" data-mp="1p9rn8iq2rqv4">
              В отличие от съемных протезов, импланты ощущаются и функционируют
              как собственные зубы. Они предотвращают атрофию костной ткани и не
              требуют обтачивания соседних здоровых зубов, что делает их лучшим
              долгосрочным решением для восстановления зубного ряда.
            </p>
          </div>
        </div>
      </section>

      {/* 3. PROCESS */}
      <section className="py-16 bg-gray-50" data-id="element-2048" data-mp="1tb4xr6444i8d">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2049" data-mp="1tablxqqar2jd">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-2050" data-mp="1y9y0c3hv2otr">
            Этапы имплантации в Dentico Clinic
          </h2>
          <div className="grid md:grid-cols-4 gap-8" data-id="element-2051" data-mp="hv6ek9f80ftf">
            {[{
            step: '01',
            title: 'Консультация',
            desc: 'Осмотр, 3D-диагностика (КТ) и составление детального плана лечения.'
          }, {
            step: '02',
            title: 'Установка',
            desc: 'Хирургический этап установки импланта под местной анестезией.'
          }, {
            step: '03',
            title: 'Заживление',
            desc: 'Период остеоинтеграции (приживления), который длится от 3 до 6 месяцев.'
          }, {
            step: '04',
            title: 'Протезирование',
            desc: 'Установка постоянной керамической коронки на имплант.'
          }].map((item, idx) => <Card key={idx} className="p-6 relative overflow-hidden" data-id="element-2052" data-mp="2me5vr21i9udo" data-mpi={idx}>
                <div className="text-6xl font-bold text-[#EFE8DE] absolute -top-4 -right-4 select-none" data-id="element-2053" data-mp="2mc2zi09rf50i">
                  {item.step}
                </div>
                <div className="relative z-10" data-id="element-2054" data-mp="1ulyi8ahaqy3i">
                  <h3 className="text-xl font-bold text-[#2B2D2F] mb-3" data-id="element-2055" data-mp="3trhs4zv6coa7">
                    {item.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-2056" data-mp="2kf0y8fc6hzz">{item.desc}</p>
                </div>
              </Card>)}
          </div>
        </div>
      </section>

      {/* 4. WHO NEEDS IMPLANTS */}
      <section className="py-16 bg-white" data-id="element-2057" data-mp="cbjhvdokocxg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2058" data-mp="ca8a72s0al12">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-2059" data-mp="3atp0wutwy2sn">
            <div data-id="element-2060" data-mp="3frgrnlitniv9">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-2061" data-mp="3fqx8k1hfqofn">
                Кому подходит имплантация?
              </h2>
              <ul className="space-y-4" data-id="element-2062" data-mp="3kp8j6efk12yx">
                {['Отсутствие одного или нескольких зубов', 'Желание отказаться от съемных протезов', 'Разрушение мостовидных конструкций', 'Необходимость восстановления жевательной функции', 'Эстетические дефекты зубного ряда'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-2063" data-mp="2ph6mte8em6re" data-mpi={idx}>
                    <CheckCircle2 className="w-6 h-6 text-forest-600 flex-shrink-0 mt-0.5" data-id="element-2064" data-mp="2kid67cxtlzn0" />
                    <span className="text-gray-700 text-lg" data-id="element-2065" data-mp="2fr4wefskwc9b">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-8" data-id="element-2066" data-mp="2asaf5ia9evrb">
                <Link to="/ru/contact" data-id="element-2067" data-mp="25tqr9cc3v9wb">
                  <Button size="lg" className="gap-2 !opacity-100 !bg-[#2F4A3F] !text-white !border !border-[#2F4A3F] hover:!bg-[#3A5A4D]" data-id="element-2068" data-mp="25us2bgt4fwe1">
                    <Calendar className="w-5 h-5" data-id="element-2069" data-mp="1wu3n4irzrpzk" />
                    Записаться на консультацию
                  </Button>
                </Link>
              </div>
            </div>
            <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-xl" data-id="element-2070" data-mp="3r7lcmbbyiwx8">
              <img src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=1200&q=80" alt="Дентальная имплантация процесс" className="absolute inset-0 w-full h-full object-cover" data-id="element-2071" data-mp="3m88l3da551ob" />
            </div>
          </div>
        </div>
      </section>

      {/* 5. BENEFITS */}
      <section className="py-16 bg-[#EFE8DE]" data-id="element-2072" data-mp="29yhdzpytmdg2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2073" data-mp="2euolvoas1z0n">
          <div className="text-center mb-12" data-id="element-2074" data-mp="2exap5bqmxsd2">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-2075" data-mp="205im9z8126s8">
              Преимущества имплантации в Dentico Clinic
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-2076" data-mp="24zejgzggvpmc">
              Мы используем передовые технологии и материалы для наилучшего
              результата.
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2077" data-mp="1w2vrpqjz27rc">
            {[{
            icon: Scan,
            title: 'Цифровое планирование',
            desc: 'Точное 3D-моделирование операции для предсказуемого результата.'
          }, {
            icon: UserCheck,
            title: 'Опытная команда',
            desc: 'Врачи с многолетним опытом в хирургической стоматологии.'
          }, {
            icon: Languages,
            title: 'Русский язык',
            desc: 'Полное понимание и комфортная коммуникация на родном языке.'
          }, {
            icon: ShieldCheck,
            title: 'Гарантия качества',
            desc: 'Используем только сертифицированные импланты мировых брендов.'
          }, {
            icon: Clock,
            title: 'Экономия времени',
            desc: 'Оптимизированные протоколы лечения для вашего комфорта.'
          }, {
            icon: MapPin,
            title: 'Удобная локация',
            desc: 'Центр Лондона, 5 минут от станции метро Angel.'
          }].map((item, idx) => <Card key={idx} className="p-6 bg-white" data-id="element-2078" data-mp="27d0f6vlbybsg" data-mpi={idx}>
                <div className="w-12 h-12 bg-[#F8F5F0] rounded-full flex items-center justify-center text-[#2F4A3F] mb-4 border border-[#D8C4A8]" data-id="element-2079" data-mp="2cb1ztkyemj61">
                  <item.icon className="w-6 h-6" data-id="element-2080" data-mp="2h9d8hscyqnmo" />
                </div>
                <h3 className="text-lg font-bold text-[#2B2D2F] mb-2" data-id="element-2081" data-mp="2m1dh0973mouv">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-2082" data-mp="2qywvna7pl3nc">{item.desc}</p>
              </Card>)}
          </div>
        </div>
      </section>

      {/* 6. FAQ */}
      <section className="py-16 bg-white" data-id="element-2083" data-mp="300msivkd0usi">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2084" data-mp="301xzf493qinu">
          <div className="text-center mb-10" data-id="element-2085" data-mp="35098vdvhir5j">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-2086" data-mp="34z7nogkr8oa3">
              Частые вопросы об имплантации
            </h2>
          </div>
          <Accordion items={faqs} data-id="element-2087" data-mp="1algdnfyik2e4" />
        </div>
      </section>

      {/* 7. INTERNAL LINKS */}
      <section className="py-12 bg-gray-50 border-t border-gray-100" data-id="element-2088" data-mp="131xd3vt87qhs">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2089" data-mp="134a40ygypb6z">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-2090" data-mp="yaflhyd3f29h">
            Смотрите также
          </h2>
          <div className="flex flex-wrap gap-4" data-id="element-2091" data-mp="td5re5ere2fb">
            <Link to="/ru/russkij-stomatolog-london" data-id="element-2092" data-mp="odaw7pnyaqog">
              <Button variant="outline" size="sm" data-id="element-2093" data-mp="oeuhxvsdltxm">
                Русскоязычный стоматолог
              </Button>
            </Link>
            <Link to="/ru/services/crowns" data-id="element-2094" data-mp="1lyp1ukrjext8">
              <Button variant="outline" size="sm" data-id="element-2095" data-mp="1h303gkr97myi">
                Коронки
              </Button>
            </Link>
            <Link to="/ru/services/hygiene" data-id="element-2096" data-mp="1c1ao4sx00n4m">
              <Button variant="outline" size="sm" data-id="element-2097" data-mp="173sm7mhef864">
                Гигиена
              </Button>
            </Link>
            <Link to="/ru/prices" data-id="element-2098" data-mp="o8942ajs5mk">
              <Button variant="outline" size="sm" data-id="element-2099" data-mp="p9x17cnwmlp">
                Цены
              </Button>
            </Link>
            <Link to="/ru/contact" data-id="element-2100" data-mp="3rsot4v7epyf3">
              <Button variant="outline" size="sm" data-id="element-2101" data-mp="ld108am626vn">
                Контакты
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* 8. CTA */}
      <section className="py-16 bg-forest-900" data-id="element-2102" data-mp="q9hrveskr3dh">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-2103" data-mp="cd4jcv60qcb5">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-2104" data-mp="gdeok5lzkyoy">
            Верните себе уверенную улыбку
          </h2>
          <p className="text-xl text-ivory/80 mb-8 max-w-2xl mx-auto" data-id="element-2105" data-mp="144abaobl53pc">
            Запишитесь на консультацию по имплантации сегодня.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-2106" data-mp="1946h8t3uf57j">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-2107" data-mp="va5r2nqyiqis">
              <Button size="lg" className="w-full gap-2 !opacity-100 !bg-[#F8F5F0] !text-[#2F4A3F] !border !border-[#F8F5F0] hover:!bg-[#EFE8DE]" data-id="element-2108" data-mp="1n1v0jwi9i4ah">
                <Calendar className="w-5 h-5" data-id="element-2109" data-mp="3ciguc21vm8vg" />
                Записаться онлайн
              </Button>
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-2110" data-mp="37je07cnfpn29">
              <Button size="lg" className="w-full gap-2 !opacity-100 !bg-[#EFE8DE] !text-[#2F4A3F] !border !border-[#D8C4A8] hover:!bg-[#2F4A3F] hover:!text-white" data-id="element-2111" data-mp="3h9ffpg1q1x5k">
                <MessageCircle className="w-5 h-5" data-id="element-2112" data-mp="2omcu1oi59gwq" />
                WhatsApp
              </Button>
            </a>
            <div className="w-full sm:w-auto" data-id="element-2113" data-mp="33jbzp6tfqzok">
              <Button variant="secondary" surface="dark" size="lg" className="w-full gap-2" onClick={() => setIsCallbackOpen(true)} data-id="element-2114" data-mp="2yjh6uxq3o00v">
                <Phone className="w-5 h-5" data-id="element-2115" data-mp="du1ie9ecsnee" />
                Заказать звонок
              </Button>
            </div>
            <a href="tel:+447345197820" className="w-full sm:w-auto" data-id="element-2116" data-mp="1ci9gdyt1e16q">
              <Button variant="secondary" surface="dark" size="lg" className="w-full gap-2" data-id="element-2117" data-mp="17iwqt6as6g0g">
                <Phone className="w-5 h-5" data-id="element-2118" data-mp="1gj1oupu3421y" />
                Позвонить
              </Button>
            </a>
            <Link to="/ru/prices" className="w-full sm:w-auto" data-id="element-2119" data-mp="1vgc6kgxbm464">
              <Button variant="secondary" surface="dark" size="lg" className="w-full" data-id="element-2120" data-mp="1vehpjdp66w7b">
                Цены
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}